
import React, { Component } from 'react'
import axios from 'axios'


const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
class Checkout extends Component {
	constructor(props) {
		super(props)

	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
		console.log(this.state)
        window.location.replace("/addpayment");
    }

	render() {
		
		return (
            <div>
            <fieldset class="w-100 col-12 mt-5 d-flex justify-content-center">
            <form  onSubmit={this.submitHandler} action="" method="delete">
              <button class="btn btn-dark button2" id="checkingout">
               Check Out here <i class="bi bi-cart-check"></i>
              </button>
          </form>
          </fieldset>
          </div>
          
		)
	}
}

export default Checkout

